<template>
    <button
      class="social-btn"
      @click="$emit('click')"
      :class="{'social-btn_unbound': authModeSelected}"
      :title="titleText">
      <slot></slot>
    </button>
</template>

<script>
import SocialBtnModes from 'src/models/SocialBtnModes';

export default {
  data: () => ({
    btnMode: '',
    SocialBtnModes,
  }),
  props: {
    mode: String,
  },
  computed: {
    authModeSelected() {
      if (this.mode === SocialBtnModes.authBtn) {
        this.btnMode = SocialBtnModes.authBtn;
        return this.btnMode;
      }
      return '';
    },
    bindModeSelected() {
      if (this.mode === SocialBtnModes.bindBtn) {
        this.btnMode = SocialBtnModes.bindBtn;
        return this.btnMode;
      }
      return '';
    },
    titleText() {
      if (this.mode === SocialBtnModes.bindBtn) {
        return 'Unbind';
      } else if (this.mode === SocialBtnModes.authBtn) {
        return 'Bind';
      }
      return '';
    },
  },
};
</script>


<style lang="scss" scoped>
.settings__socials {
  .social-btn {
    border-color: $red-color3;
    background-color: $red-color3;
    &:hover {
      border-color: $red-color3;
      background-image: url("~src/assets/svg/bond.svg");
      .icon-base {
        display: none;
      }
    }
    &_unbound {
      background-color: transparent;
      &:hover {
        background-image: url("~src/assets/svg/unbond.svg");
      }
    }
  }
}
.social-btn {
  @include removeBtnDefaults;
  background: $white-color2;
  border: 2px solid transparent;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: inline-flex;
  vertical-align: top;
  position: relative;
  transition: opacity,  $transition;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 14px 26px;
  .icon-base,
  svg {
    margin: auto;
  }
  &__cross {
    position: absolute;
    top: -5px;
    right: -7px;
    border: 2px solid $red-color3;
    border-radius: 50%;
    transform: scale(0.7);
    padding: 6px;
    width: 28px;
    height: 28px;
    background: $white-color2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/uikit/SocialBtn.vue